<table mat-table
       [dataSource]="dataSource"
       matSort>
    <ng-container matColumnDef="dueMonth">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.dueMonth.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            {{ contractState.dueMonth | date: 'MM/yyyy'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="fte">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.fte.fullLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState; let i = index;">
            <span>
                {{contractState.budgetaryFte ? contractState.budgetaryFte : '-'}}
            </span>
            <span>[ {{contractState.contractFte ? contractState.contractFte : '-'}} ]</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="scales">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.scales.fullLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.scalePayment) {
                <span [matTooltip]="contractState.scalePayment.externalDescription">
                    {{ contractState.scalePayment.externalId }}
                </span>
            } @else {
                <span> - </span>
            }
            @if (contractState.parallelScalePayment) {
                <span>&#123;</span>
                <span [matTooltip]="contractState.parallelScalePayment.externalDescription">
                    {{ contractState.parallelScalePayment.externalId }}
                </span>
                <span>&#125;</span>
            } @else {
                <span> &#123; - &#125; </span>
            }
            @if (contractState.superiorScalePayment) {
                <span>[</span>
                <span [matTooltip]="contractState.superiorScalePayment.externalDescription">
                    {{ contractState.superiorScalePayment.externalId }}
                </span>
                <span>]</span>

            } @else {
                <span> [ - ] </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="scaleSeniority">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.scaleSeniority.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.scaleSeniority) {
                <span> {{ contractState.scaleSeniority | date: 'dd-MM-YYYY'}} </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="branch">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.branch.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.branch) {
                <span [matTooltip]="contractState.branch.name">
                    {{ contractState.branch.code }}
                </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="professionalStatus">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.professionalStatus.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.professionalStatus) {
                <span [matTooltip]="contractState.professionalStatus.description">
                    {{ contractState.professionalStatus.code }}
                </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="scaleAdministrative">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.scaleAdministrative.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.scaleAdministrative) {
                <span [matTooltip]="contractState.scaleAdministrative.externalDescription">
                    {{ contractState.scaleAdministrative.externalId }}
                </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="seniority">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.seniority.shortLabel' | translate}}
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.seniority) {
                <span>
                    {{ contractState.seniority | date: 'dd-MM-YYYY'}}
                </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="salaryBase">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{'agent.contractState.salaryBase.shortLabel' | translate}}€
        </th>
        <td mat-cell
            *matCellDef="let contractState">
            @if (contractState.salaryBase) {
                <span>
                    {{ contractState.salaryBase | formatSalarayBase: contractState.indexValue:contractState.contractFte }}
                </span>
            } @else {
                <span> - </span>
            }
        </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
